import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  id: number
}

type Response = ITypeTicketData

export const getData = async (props: Props): Promise<Response> => {
  const { id } = props

  const endpoint = ApiEndpoint.v4.typeticket.data(id)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
